import 'core-js/es/array/from';

let adminManageAlerts = {
    alertsElement: document.querySelector('.admin-manage-alerts'),
    selectAllElement: null,
    checkboxesList: [],
    alertsList: [],
    init() {
        if (this.alertsElement !== null) {
            this.selectAllElement = this.alertsElement.querySelector('#alert--select-all');
            if (!this.selectAllElement) return;
            this.alertsList = Array.from(
                this.alertsElement.querySelectorAll('.slices-list__slice:not(.slices-list__slice--select-all) input')
            );
            this.checkboxesList = Array.from(this.alertsElement.querySelectorAll('.slices-list__slice input'));
            this.handleCheckChange();
            this.addListeners();
        }
    },
    addListeners() {
        this.alertsList.forEach(el => {
            el.addEventListener('change', () => this.handleCheckChange());
        });
        this.selectAllElement.addEventListener('change', () => this.handleSelectAllChange());
        this.alertsElement.addEventListener('keydown', e => this.handleKeyDown(e));
    },
    handleCheckChange() {
        let anyNotChecked = this.alertsList.filter(el => !el.checked);
        this.selectAllElement.indeterminate =
            anyNotChecked.length > 0 && anyNotChecked.length !== this.alertsList.length;
        this.selectAllElement.checked = !anyNotChecked.length > 0;
        this.selectAllElement.setAttribute(
            'aria-checked',
            (this.selectAllElement.indeterminate && 'mixed') || this.selectAllElement.checked
        );
    },
    handleSelectAllChange() {
        this.alertsList.forEach(el => {
            el.checked = this.selectAllElement.checked;
        });
        this.selectAllElement.setAttribute('aria-checked', this.selectAllElement.checked);
    },

    /**
     * @param {KeyboardEvent} event
     */
    handleKeyDown(event) {
        const target = event.target;
        let key = event.which.toString();
        // 33 = Page Up, 34 = Page Down
        const ctrlModifier = event.ctrlKey && key.match(/33|34/);

        // Is this coming from an checkbox
        if (target.parentNode.classList.contains('slices-list__checkbox')) {
            // Up/ Down arrow and Control + Page Up/ Page Down keyboard operations
            // 38 = Up, 40 = Down
            if (key.match(/38|40/) || ctrlModifier) {
                let index = this.checkboxesList.indexOf(target);
                let direction = key.match(/34|40/) ? 1 : -1;
                let length = this.checkboxesList.length;
                let newIndex = (index + length + direction) % length;

                this.checkboxesList[newIndex].focus();

                event.preventDefault();
            } else if (key.match(/35|36/)) {
                // 35 = End, 36 = Home keyboard operations
                switch (key) {
                    // Go to first checkbox
                    case '36':
                        this.checkboxesList[0].focus();
                        break;
                    // Go to last checkbox
                    case '35':
                        this.checkboxesList[this.checkboxesList.length - 1].focus();
                        break;
                }
                event.preventDefault();
            }
        }
    },
};
UX.adminManageAlerts = adminManageAlerts;
UX.adminManageAlerts.init();
